export const GET_DATA_AGENT_STATUS = 'GET_DATA_AGENT_STATUS';
export const GET_DATA_AGENT_FROM_GROUP_ID = 'GET_DATA_AGENT_FROM_GROUP_ID';
export const OPEN_LISTEN_DIALOG = 'OPEN_LISTEN_DIALOG';
export const CLOSE_LISTEN_DIALOG = 'CLOSE_LISTEN_DIALOG';
export const JOIN_CALL = 'JOIN_CALL';
export const SUBMIT_SUCCEED = 'SUBMIT_SUCCEED';
export const SUBMIT_FAILED = 'SUBMIT_FAILED';
export const RESET_MESSAGE = 'RESET_MESSAGE';
export const RESET_LOADING = 'RESET_LOADING';